import ApiEndpoint from "./ApiEndpoint";
import { AxiosResponse } from "axios";
import { NumberishId } from "../../../model/type";
import { OfferCreatorFilterOptions } from "../../../view/page/offer-panel/offer-creator/common/Filters";

export class Endpoint extends ApiEndpoint {
    public get = (offerId: NumberishId): Promise<AxiosResponse<OfferCreatorFilterOptions>> => {
        return this.connection.get('/offers/' + offerId + '/filters-options');
    }
}
